import classNames from "classnames";
import moment from "moment";
import React from "react";
import { TBallastRecord } from "../../../../../redux/app/ballast/@types";
import { TBallast_Ballast } from "../../../../../redux/app/ballast/groups/ballast";
import CommaSeparator from "../../../../_common/CommaSeparator";
import BallastTableRows from "../_elements/BallastTableRows";
import { TBallast_Failure } from "redux/app/ballast/groups/failure";
import versions from "../../../../../redux/app/ballast/versions";

type OwnProps = {
	ballastRecord: TBallastRecord;
	isStrikedOff?: boolean;
};
type InternalOperationPreviewProps = OwnProps;
function FailureBWMSOperationPreview(props: InternalOperationPreviewProps) {
	const record = props.ballastRecord as TBallast_Failure;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);
	function renderMain() {
		return (
			<BallastTableRows
				record={record}
				tableRows={[
					[operationDate, "F", "1", renderItem1()],
					[null, null, "2", renderItem2()],
					[null, null, "3", renderItem3()],
					[null, null, "4", renderItem4()],
					[null, null, "NOTE", record.remarks],
				]}
			/>
		);
	}

	// MEPC.369(80)
	function renderItem1() {
		const smtStartDate = record.failureDateTime.date;
		const smtStartTime = record.failureDateTime.time;
		if (record.failureDateTime.date && record.failureDateTime.time) {
			const dateTimeLocal = `${smtStartDate}T${smtStartTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							{utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at{" "}
							{record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							{utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at Lat{" "}
							{record.placeOfBallast.startPosition.latitude} / Long{" "}
							{record.placeOfBallast.startPosition.longitude}
						</>
					) : null}
				</>
			);
		} else {
			return <h4 className="font-medium uppercase">-----</h4>;
		}
	}
	function renderItem2() {
		return (
			<h4 className="font-medium uppercase">
				{record.operationType === "Uptake" ||
				record.operationType === "Discharge"
					? record.operationType
					: "-----"}
			</h4>
		);
	}
	function renderItem3() {
		return (
			<h4 className="font-medium uppercase">
				{record.circumstantialRemarks ? record.circumstantialRemarks : "-----"}
			</h4>
		);
	}
	function renderItem4() {
		if (
			record.inOperabilitiesRemarks &&
			record.inOperabilitiesRemarks.length > 2
		) {
			return (
				<h4 className="font-medium uppercase">
					{record.inOperabilitiesRemarks}
				</h4>
			);
		} else if (
			record.operationalDateTime.date.length > 0 &&
			record.operationalDateTime.time
		) {
			const smtEndDate = record.operationalDateTime.date;
			const smtEndTime = record.operationalDateTime.time;
			const dateTimeLocal = `${smtEndDate}T${smtEndTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					{record.operationalPlace.place === "IN_PORT" ? (
						<>
							{utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at{" "}
							{record.operationalPlace.portName}, BWMS made operational
						</>
					) : null}
					{record.operationalPlace.place === "AT_SEA" ? (
						<>
							{utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at Lat{" "}
							{record.operationalPlace.startPosition.latitude} / Long{" "}
							{record.operationalPlace.startPosition.longitude} , BWMS made
							operational
						</>
					) : null}
				</>
			);
		} else {
			return <h4 className="font-medium uppercase">-----</h4>;
		}
	}

	return renderMain();
}

export default FailureBWMSOperationPreview;
